import styled from '@emotion/styled';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors';
import FONTS from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQuery';
import UTILS from '@zola/zola-ui/src/styles/emotion/utils';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import RefreshIcon from '@zola/zola-ui/src/components/SvgIcons/Refresh';
import DeleteIcon from '@zola/zola-ui/src/components/SvgIcons/DeleteIcon';
import { PhotoIcon as Photo } from '@zola/zola-ui/src/components/SvgIconsV3/Photo';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

export const PreviewIcon = styled.img`
  width: 38px;
  height: 38px;
  margin-right: 18px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid white;
  padding: 1px;
`;

export const PhotoIcon = styled(Photo)`
  margin-right: ${props => props.theme.SPACING.XS};
`;

export const ButtonBox = styled.div`
  width: 100%;

  ${MEDIA_QUERY.DESKTOP} {
    width: initial;
  }

  svg {
    margin-left: 10px;
  }
`;

export const StyledButton = styled(ButtonV3)`
  white-space: nowrap;
`;

export const DropdownBox = styled.div`
  align-items: center;
  background: ${COLORS.WHITE};
  border-radius: 4px;
  border: 2px solid ${COLORS.ALTO};
  display: flex;
  flex-direction: column;
  font-size: ${FONTS.FONT_SIZE_SMALL};
  font-weight: ${FONTS.FONT_WEIGHT_REGULAR};
  line-height: 24px;
  position: absolute;
  z-index: 1;
  ${UTILS.defaultBoxShadow};
`;

export const PhotoOption = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  padding: 10px ${SPACING.MD};
  width: 232px;

  &:hover {
    background: ${COLORS.CLOUD};
  }
`;

export const SwapIcon = styled(RefreshIcon)`
  transform: translateX(-4px) scale(0.7);
  margin-right: -4px;
`;

export const RemoveIcon = styled(DeleteIcon)`
  margin-right: 6px;
`;
